import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles({
    root: {
        lineHeight: 0,
    },

    loading: {
        position: 'absolute',
        textAlign: 'center',
        top: 8,
        left: 0,
        right: 0,
    },
});

const FadeContainer = (props) => <div {...props} />;

const LoadingIcon = ({ isLoading, children, className }) => {
    const classes = useStyles();
    const ref = useRef(null);
    const [dimensions, setDimensions] = React.useState(null);

    React.useEffect(() => {
        if (isLoading && !dimensions) {
            const dim = ref.current.getBoundingClientRect();
            setDimensions({ width: dim.width, height: dim.height });
        }
    }, [ref, isLoading, dimensions]);

    return (
        <Box ref={ref} className={classes.root}>
            <Fade
                in={!isLoading}
                style={{
                    transitionDelay: isLoading ? '300ms' : '0ms',
                }}
                timeout={{
                    enter: 300,
                    exit: 800,
                }}
            >
                <FadeContainer>{children}</FadeContainer>
            </Fade>
            <Fade
                in={isLoading}
                className={classNames(classes.loading, className)}
                style={{
                    transitionDelay: isLoading ? '800ms' : '0ms',
                }}
                timeout={{
                    enter: 1000,
                }}
                unmountOnExit
            >
                <FadeContainer>
                    {dimensions && (
                        <CircularProgress
                            size={Math.min(dimensions.width, dimensions.height) - 10}
                        />
                    )}
                </FadeContainer>
            </Fade>
        </Box>
    );
};

LoadingIcon.propTypes = {
    isLoading: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

LoadingIcon.defaultProps = {
    isLoading: false,
    className: null,
};

export default LoadingIcon;
